import { render, staticRenderFns } from "./emProfressorDetail.vue?vue&type=template&id=16ae5436&scoped=true&"
import script from "./emProfressorDetail.vue?vue&type=script&lang=js&"
export * from "./emProfressorDetail.vue?vue&type=script&lang=js&"
import style0 from "./emProfressorDetail.vue?vue&type=style&index=0&id=16ae5436&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ae5436",
  null
  
)

export default component.exports